import { createLearnCarousel } from "@jpj/game-shell";

/* The learn-slides reveal — its mechanics live in @jpj/game-shell; this game
   only declares how many slides #learnSlides holds. */
const learn = createLearnCarousel({ slideCount: 4 });

export const openLearn = (): void => learn.open();
export const closeLearn = (): void => learn.close();
export const stepLearn = (delta: number): void => learn.step(delta);
export const gotoLearn = (i: number): void => learn.goto(i);
